function escapeCsvCell(value) {
  const s = String(value ?? "");
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function buildPromptCsv(content) {
  return `content\n${escapeCsvCell(content)}\n`;
}

function slugForFilename(name) {
  const slug = String(name ?? "")
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .slice(0, 48);
  return slug || "widget";
}

function triggerBrowserDownload(filename, csvText) {
  const blob = new Blob([csvText], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

/**
 * Download short / map / reduce org LLM prompts as three separate CSV files.
 */
export function downloadOrgLlmPromptsCsv({
  metricId,
  widgetName,
  shortPrompt,
  longMapPrompt,
  longReducePrompt,
}) {
  const mid = Number(metricId) || "metric";
  const slug = slugForFilename(widgetName);
  const files = [
    {
      name: `org-llm-prompt-m${mid}-short-${slug}.csv`,
      content: buildPromptCsv(shortPrompt),
    },
    {
      name: `org-llm-prompt-m${mid}-map-${slug}.csv`,
      content: buildPromptCsv(longMapPrompt),
    },
    {
      name: `org-llm-prompt-m${mid}-reduce-${slug}.csv`,
      content: buildPromptCsv(longReducePrompt),
    },
  ];

  files.forEach((file, index) => {
    window.setTimeout(() => {
      triggerBrowserDownload(file.name, file.content);
    }, index * 120);
  });
}
